<template>
  <!-- 搜索栏 -->
  <el-form :inline="true" class="search-bar">
    <el-form-item>
      <el-select
          v-model="filters.selectedOrganization"
          placeholder="请选择机构"
          clearable
          style="width: 200px"
      >
        <el-option
            v-for="organization in organizations"
            :key="organization.organizationID"
            :label="organization.orgName"
            :value="organization.organizationID"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 学员姓名下拉框 -->
    <el-form-item>
      <el-select
          v-model="filters.selectedUser"
          placeholder="请选择学员"
          clearable
          style="width: 200px"
      >
        <el-option
            v-for="user in users"
            :key="user.value"
            :label="user.label"
            :value="user.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 培训计划下拉框 -->
    <el-form-item>
      <el-select
          v-model="filters.selectedPlan"
          placeholder="请选择培训计划"
          clearable
          style="width: 200px"
      >
        <el-option
            v-for="plan in plans"
            :key="plan.value"
            :label="plan.label"
            :value="plan.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 搜索按钮 -->
    <el-form-item>
      <el-button type="primary" @click="fetchExamDetails">搜索</el-button>
    </el-form-item>
  </el-form>


  <div class="container">
    <!-- 切换图表类型 -->
    <el-row justify="center" style="margin-bottom: 20px;">
      <el-button type="primary" @click="showBarChart">柱状图</el-button>
      <el-button type="success" @click="showPieChart">饼状图</el-button>
    </el-row>

    <!-- 选择查看方式 -->
    <el-row justify="center" style="margin-bottom: 20px;">
      <el-select v-model="selectedGroup" placeholder="选择分组方式" style="width: 200px;" @change="processData">
        <el-option label="按机构" value="organization"></el-option>
        <el-option label="按计划" value="plan"></el-option>
      </el-select>
    </el-row>

    <!-- 图表容器 -->
    <div id="chart" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import axios from "@/axios";
import { ElMessage } from "element-plus";
export default {
  data() {
    return {
      chartType:'bar',
      chart: null, // 图表实例
      data: [], // 存储从后端获取的数据
      organizations: [], // 机构列表
      users: [], // 学员列表
      plans: [], // 培训计划列表
      selectedGroup: "organization", // 默认分组方式：按机构
      chartData: [], // 存储处理后的数据
      filters: {
        selectedOrganization: null,
        selectedUser: null,
        selectedPlan: null,
      },
    };
  },
  mounted() {
    // 初始化 ECharts 实例
    this.chart = echarts.init(document.getElementById("chart"));
    // 获取机构、学员、培训计划数据
    this.fetchInitialData();
  },
  methods: {
    // 获取初始的机构、学员和培训计划列表
    fetchInitialData() {
      // // 假设你有相应的 API 接口可以获取这些数据
      // axios.get("/organizations").then((response) => {
      //   this.organizations = response.data;
      // });
      // axios.get("/users").then((response) => {
      //   this.users = response.data;
      // });
      // axios.get("/plans").then((response) => {
      //   this.plans = response.data;
      // });
    },

    // 根据选择的分组方式处理数据
    processData() {
      const groupedData = {};
      const groupKey = this.selectedGroup === "organization" ? "orgName" : "planName";

      // 按分组字段分组并累加分数
      this.data.forEach((item) => {
        const group = item[groupKey];
        if (!groupedData[group]) {
          groupedData[group] = {totalScore: 0, count: 0};
        }
        groupedData[group].totalScore += item.score;
        groupedData[group].count += 1;
      });

      // 计算平均分并格式化为图表所需数据
      this.chartData = Object.entries(groupedData).map(([key, value]) => ({
        name: key,
        value: value.totalScore / value.count,
      }));

      // 更新图表
      this.updateChart();
    },

    // 显示柱状图
    showBarChart() {
      this.chartType = "bar"; // 设置图表类型为柱状图
      this.updateChart();
    },

    // 显示饼状图
    showPieChart() {
      this.chartType = "pie"; // 设置图表类型为饼状图
      this.updateChart();
    },

    // 根据当前类型和数据更新图表
    updateChart() {
      const option = {
        title: {
          text: `平均分统计（${this.chartType === "bar" ? "柱状图" : "饼状图"}）`,
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: this.chartType === "bar" ? "{b}: {c}" : "{a} <br/>{b}: {c} ({d}%)",
        },
        xAxis: this.chartType === "bar"
            ? { type: "category", data: this.chartData.map((item) => item.name) }
            : null, // 饼状图时不设置 xAxis
        yAxis: this.chartType === "bar"
            ? { type: "value" }
            : null, // 饼状图时不设置 yAxis
        series: [
          {
            name: "平均分",
            type: this.chartType,
            data: this.chartData,
            ...(this.chartType === "bar"
                ? { itemStyle: { color: "#409EFF" } }
                : {
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                }),
          },
        ],
      };

      this.chart.setOption(option, true); // 强制更新以清除旧配置
    },


    // 获取考试详情并根据筛选条件更新图表数据
    fetchExamDetails() {
      const params = {
        userid: this.filters.selectedUser ,
        planId: this.filters.selectedPlan ,
        organizationID: this.filters.selectedOrganization ,

      };

      axios
          .get("/Exam/details", {params})
          .then((response) => {
            if (response.data.success) {
              const data = response.data.data;
              this.data = data;
              this.extractDropdownOptions(data);
              this.processData(); // 获取数据后处理并更新图表
            } else {
              this.$message.error("获取考试详情失败！");
            }
          })
          .catch(() => {
            this.$message.error("获取考试详情失败！");
          });
    },
    // 提取并去重学员、培训计划和机构选项
    extractDropdownOptions(data) {
      const uniqueUsers = new Set();
      const uniquePlans = new Set();
      const uniqueOrganizations = new Set();

      data.forEach((item) => {
        uniqueUsers.add(item.userId);
        uniquePlans.add(item.training_plan_id);
        uniqueOrganizations.add(item.organizationID);
      });

      this.users = Array.from(uniqueUsers).map((userId) => {
        const user = data.find((item) => item.userId === userId);
        return {label: user.name, value: userId};
      });

      this.plans = Array.from(uniquePlans).map((planId) => {
        const plan = data.find((item) => item.training_plan_id === planId);
        return {label: plan.planName, value: planId};
      });

    },
  },
  created() {
    // 获取考试详情
    this.fetchExamDetails();
    // 获取机构列表
    axios
        .get("/organization/orglist")
        .then((res) => {
          this.organizations = res.data.data;
        })
        .catch(() => {
          ElMessage.error("获取机构列表失败");
        });
  }
};
</script>

<style scoped>
.container {
  width: 80%;
  margin: auto;
  padding: 20px;
  text-align: center;
}
</style>
